'use strict';

angular.module('shiftTraderApp')
  .factory('AvailabilityRules', function (ServerUrls, Session, $http, TimeService, $injector, $q) {

    //Notification model constructor
    var AvailabilityRule = function(values) {
      var A = {};

      A.$setStartEnd = function(currentDate) {
        if (A._type === 'weekly') {
          A.start = moment(currentDate).days(A.day_of_week).hours(0).minutes(A.start_time_minutes).seconds(0).milliseconds(0);
          A._startString = A.start.format();
          A.end = moment(currentDate).days(A.day_of_week).hours(0).minutes(A.end_time_minutes).seconds(0).milliseconds(0);
          A._endString = A.end.format();
        } else {
          A.start = TimeService.getBeginningOfDayFromDate(A.start_date);
          if (!lodash.isNull(A.start_time_minutes)) {
            A.start = A.start.minutes(A.start_time_minutes);
          }

          A._startString = A.start.format();
          if (!lodash.isNull(A.end_time_minutes)) {
            A.end = TimeService.getBeginningOfDayFromDate(A.end_date);
            A.end = A.end.minutes(A.end_time_minutes);
          } else {
            A.end = TimeService.getBeginningOfDayFromDate(A.end_date).add(1, 'days');
          }

          A._endPrevDay = TimeService.getBeginningOfDayFromDate(A.end_date);
          A._endString = A.end.format();
        }

        if (A.approved_at) {
          A.approved_at = moment(A.approved_at).tz(tzn);
        }

        if (A.cancelled_at) {
          A.cancelled_at = moment(A.cancelled_at).tz(tzn);
        }

        A.range_twix = moment(A.start).twix(moment(A.end));
        A.created_at_tz = moment(A.created_at).tz(tzn);
        A._created_at_unix = moment(A.created_at).unix();
        A._startTimeUnix = moment(A.start).unix();
      };

      angular.extend(A, values);
      var tzn = Session.getTimezone();
      A._type = (A.recurring && A.repeats_on_weekly) ? 'weekly' : 'single';
      A.$setStartEnd(moment.utc().tz(tzn));

      if (A.user) {
        var Users = $injector.get('Users');
        A.user = Users.initWithData(A.user);
      }

      A.$overlapsWithRule = function(otherRule) {
        return this.range_twix.overlaps(otherRule.range_twix);
      };

      A.$isApproved = function() {
        return A.active && !lodash.isNull(A.approved_by) && lodash.isNull(A.cancelled_by);
      };

      A.$isDisapproved = function() {
        return !A.active && !lodash.isNull(A.approved_by) && lodash.isNull(A.cancelled_by);
      };

      A.$isPending = function() {
        return A.active && lodash.isNull(A.approved_by) && lodash.isNull(A.cancelled_by);
      };

      A.$isExpired = function() {
        return lodash.isNull(A.approved_by) && lodash.isNull(A.cancelled_by) && TimeService.getNowInStoreTime().isAfter(A.start);
      };

      A.$isCancelled = function() {
        return !lodash.isNull(A.cancelled_by) && A.user.id === A.cancelled_by;
      };

      A.$wasRemoved = function() {
        return !lodash.isNull(A.cancelled_by) && A.user.id !== A.cancelled_by;
      };

      A.$wasCancelledOrRemoved = function() {
        return !lodash.isNull(A.cancelled_by);
      };

      A.$usedOverrideToken = function() {
        return A.metadata && A.metadata.override_token_id && A.metadata.override_token_granted_by_id;
      }

      A.$getNumberOfFullAndPartialDays = function() {
        var startOfStartDay = TimeService.getBeginningOfDayFromDateWithOrgSetting(A.start);

        if (startOfStartDay.isAfter(A.start)) {
          startOfStartDay.subtract(1, 'day');
        }

        var ret = {
          full: 0,
          part: 0
        };

        var currStart = moment(startOfStartDay);
        var currEnd = moment(currStart).add(1, 'day');
        var len;

//        if (A.$isPending()) {
//          console.log('PENDING');
//          console.log('currStart: ', currStart.format());
//          console.log('currEnd: ', currEnd.format());
//          console.log('initial range:', currStart.twix(currEnd).format());
//          console.log(A);
//          console.log('DayOff Range: ', A.range_twix.format());
//        }
        while (currStart.isBefore(A.end)) {
          len = currStart.twix(currEnd).intersection(A.range_twix).length('minutes') / 60.0;
//          if(A.$isPending()) {
//            console.log('currRange: ', currStart.twix(currEnd).format());
//            console.log('intersection: ', currStart.twix(currEnd).intersection(A.range_twix).format());
//            console.log('intersection: ', A.range_twix.intersection(currStart.twix(currEnd)).format());
//            console.log('len:', len);
//          }

          if (len >= 24) {
            ret.full += 1;
          } else if (len > 0) {
            ret.part += 1;
          }

          currStart = moment(currStart).add(1, 'day');
          currEnd = moment(currEnd).add(1, 'day');
        }
        return ret;
      };


      A.$minimalIntervalTimeFormat = function() {
        var tmp = moment(A.start).twix(moment(A.end));
        return TimeService.minimalIntervalTimeFormat(tmp).strings.interval;
      };

      A.$getLastMessage = function() {
        return lodash.last(A.messages);
      };

      A.$getMessageForSetId = function(availSetId) {
        var entry = lodash.find(A.messages, {availability_set_id: availSetId});

        // see if there is a message with an availability_set_id
        if (lodash.isUndefined(entry)) {
          var altMessage = lodash(A.messages).filter(function(msg) {
            return !lodash.has(msg, 'availability_set_id') || parseInt(msg.availability_set_id) < parseInt(availSetId);
          }).last();
        }


        if (!lodash.isUndefined(entry)) {
          return entry;
        } else if (!lodash.isUndefined(altMessage)) {
          return altMessage;
        } else {
          return undefined;
        }
      };

      A.$update = function(updateData) {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + 'user_availabilities/' + this.id, updateData)
          .then(function(response) {
            that = lodash.extend(that, response.data);
            return that;
          }, function(response) {
            console.log('Error in AvailabilityRule.$makeInactive');
            return $q.reject(response);
          });
      };

      A.$makeInactive = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + 'user_availabilities/' + this.id, {
          active: false
        })
          .then(function(response) {
            that.active = false;
            that.cancelled_by = response.data.cancelled_by;
            that.cancelled_at = moment(response.data.cancelled_at).tz(tzn);
            that.inactive_date = moment(response.data.inactive_date).tz(tzn);
            that.messages = response.data.messages;

            return response.data;
          }, function(response) {
            console.log('Error in AvailabilityRule.$makeInactive');
            return $q.reject(response);
          });
      };

      A.$approve = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + 'user_availabilities/' + this.id, {
          action: 'approve'
        })
          .then(function(response) {
            that.approved_by = response.data.approved_by;
            that.approved_by_user = response.data.approved_by_user;
            that.approved_at = moment(response.data.approved_at).tz(tzn);
            that.messages = response.data.messages;
            that.active = response.data.active;
            return response.data;
          }, function(response) {
            console.log('Error in AvailabilityRule.$approve');
            return $q.reject(response);
          });
      };

      A.$disapprove = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + 'user_availabilities/' + this.id, {
          action: 'disapprove'
        })
          .then(function(response) {
            that.approved_by = response.data.approved_by;
            that.approved_at = moment(response.data.approved_at).tz(tzn);
            that.approved_by_user = response.data.approved_by_user;
            that.inactive_date = moment(response.data.inactive_date).tz(tzn);
            that.messages = response.data.messages;
            that.active = response.data.active;
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      A.$remove = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + 'user_availabilities/' + this.id, {
          action: 'remove'
        })
          .then(function(response) {
            that.cancelled_by = response.data.cancelled_by;
            that.cancelled_at = moment(response.data.cancelled_at).tz(tzn);
            that.inactive_date = moment(response.data.inactive_date).tz(tzn);
            that.messages = response.data.messages;
            that.active = response.data.active;
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      A.$sendMessage = function(messageText, usr) {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + 'user_availabilities/' + this.id, {
          message: {
            text: messageText,
            user_id: usr.id,
            user_first_name: usr.first_name,
            user_last_name: usr.last_name
          }
        })
            .then(function(response) {
              that.messages = response.data.messages;
              return response.data;
            }, function(response) {
              console.log('Error in AvailabilityRule.$approve');
              return $q.reject(response);
            });
      };

      return A;
    };

    var AvailabilityRules = {};

    AvailabilityRules.getById = function(id) {
      return $http.get(ServerUrls.current.railsApi + 'user_availabilities/' + id)
        .then(function(response) {
          return new AvailabilityRule(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    AvailabilityRules.createRule = function (data) {
      return $http.post(ServerUrls.current.railsApi + 'user_availabilities', data)
        .then(function (response) {
          return new AvailabilityRule(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    AvailabilityRules.getAll = function(params) {
      var config = {
        params: params
      };

      return $http.get(ServerUrls.current.railsApi + 'user_availabilities', config)
          .then(function(response) {
            return lodash.map(response.data, function(ar) {
              return new AvailabilityRule(ar);
            });
          }, function(response) {
            return $q.reject(response);
          });

    };

    AvailabilityRules.getAllApprovedDaysOff = function(extraParams) {
      var data = {
        //organization: 'primary',
        status: 'approved',
        type: 'daysoff',
        active: true
      };

      if (extraParams) {
        lodash.extend(data, extraParams);
      }

      return AvailabilityRules.getAll(data);
    };

    AvailabilityRules.getAllDaysOffNeedingApproval = function() {
      var data = {
        //organization: 'primary',
        status: 'awaitingapproval',
        type: 'daysoff',
        active: true
      };

      return AvailabilityRules.getAll(data);
    };

    AvailabilityRules.getRecentlyUpdatedOrNewDaysOff = function(params) {
      var data = {
        type: 'daysoff',
        mode: 'recent_new_or_updated'
      };

      angular.extend(data, params);

      return AvailabilityRules.getAll(data);
    };

    AvailabilityRules.initWithData = function(data) {
      return new AvailabilityRule(data);
    };

    return AvailabilityRules;
  });
